export const marketingParamsAvailable = (
  marketingParams: qs.ParsedQs,
): boolean => {
  const { tracking, utm_campaign, utm_source, utm_medium, utm_content } =
    marketingParams;
  return Boolean(
    tracking || utm_campaign || utm_source || utm_medium || utm_content,
  );
};
